import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login, continueAsGuest } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!username || !password) return setErr("Nhập tên đăng nhập và mật khẩu");
    setBusy(true);
    setErr("");
    try {
      const { ok, data } = await login(username.trim(), password);
      if (!ok) {
        setErr(data.message || "Đăng nhập thất bại");
        setBusy(false);
      }
    } catch {
      setErr("Không kết nối được máy chủ");
      setBusy(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") submit();
  };

  return (
    <div style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      background: "radial-gradient(1100px 600px at 50% -10%, var(--primary-soft), transparent 60%), var(--bg)",
      minHeight: "100vh",
      width: "100%",
    }}>
      <div style={{ width: "100%", maxWidth: "396px" }}>
        {/* Brand Header */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "26px" }}>
          <div style={{
            width: "52px",
            height: "52px",
            borderRadius: "15px",
            background: "var(--primary)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 12px 30px -8px var(--primary-soft)",
            marginBottom: "14px",
          }}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"></path>
              <circle cx="12" cy="12" r="2.7" fill="#fff" stroke="none"></circle>
            </svg>
          </div>
          <div style={{ fontSize: "23px", fontWeight: 800, letterSpacing: "-.4px", color: "var(--text)" }}>Argus</div>
          <div style={{ fontSize: "13px", color: "var(--faint)", marginTop: "3px" }}>Server observability · Sign in to continue</div>
        </div>

        {/* Login Card */}
        <div style={{
          background: "var(--surface)",
          border: "1px solid var(--border)",
          borderRadius: "18px",
          padding: "26px",
          boxShadow: "var(--shadow)",
        }}>
          {err && (
            <div style={{
              background: "var(--red-soft)",
              border: "1px solid var(--red)",
              color: "var(--red)",
              fontSize: "13px",
              padding: "10px 14px",
              borderRadius: "10px",
              marginBottom: "18px",
              fontFamily: "var(--font-mono)",
              textAlign: "center",
            }}>
              {err}
            </div>
          )}

          <div className="field-lbl">Username</div>
          <input
            className="field-inp"
            type="text"
            value={username}
            autoFocus
            placeholder="Tên đăng nhập"
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={busy}
          />

          <div className="field-lbl">Password</div>
          <input
            className="field-inp"
            type="password"
            value={password}
            placeholder="••••••••"
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={busy}
            style={{ marginBottom: "20px" }}
          />

          <button
            onClick={submit}
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "11px",
              background: "var(--primary)",
              border: "none",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "700",
              cursor: busy ? "not-allowed" : "pointer",
              boxShadow: "0 8px 20px -8px var(--primary-soft)",
              transition: "all 0.2s ease",
            }}
            className="login-btn-submit"
            disabled={busy}
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>

          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "18px 0",
            color: "var(--faint)",
            fontSize: "12px",
          }}>
            <span style={{ flex: 1, height: "1px", background: "var(--border)" }}></span>
            or
            <span style={{ flex: 1, height: "1px", background: "var(--border)" }}></span>
          </div>

          <button
            onClick={continueAsGuest}
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "11px",
              background: "transparent",
              border: "1px solid var(--border2)",
              color: "var(--dim)",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            className="login-btn-guest"
            type="button"
          >
            Continue as guest · read-only
          </button>
        </div>

        {/* Footer Hint */}
        <div style={{
          textAlign: "center",
          fontSize: "12px",
          color: "var(--faint)",
          marginTop: "16px",
          lineHeight: "1.6",
        }}>
          Guest views metrics only · Operator runs apps &amp; PID · Admin has full access
        </div>
      </div>

      <style>{`
        .login-btn-submit:hover:not(:disabled) {
          filter: brightness(1.07);
        }
        .login-btn-guest:hover {
          color: var(--text) !important;
          border-color: var(--dim) !important;
        }
      `}</style>
    </div>
  );
}
